export const CONTENT_ROUTE_PATHS = {
  content: '/help-center/content',
};

/**
 * Gateway paths mirror the legacy retool controller (PublicHelpCenterController), dropping the
 * `/public` prefix, per PANEL_HC_API_CONTRACT.md. AP_API_BASE_URL supplies the `/panel` prefix.
 */
export const CONTENT_API_PATHS = {
  categories: '/v1/api/platform/help-center/categories',
  createCategory: '/v1/api/platform/help-center/categories',
  updateCategory: '/v1/api/platform/help-center/categories/:externalId',
  deleteCategory: '/v1/api/platform/help-center/categories/delete/:externalId',
  categoryArticles: '/v1/api/platform/help-center/categories/:externalId/articles',
  importArticle: '/v1/api/platform/help-center/category/:externalId/article/:intercomId',
  resyncArticle: '/v1/api/platform/help-center/article/:intercomId',
  deleteArticle: '/v1/api/platform/help-center/articles/delete/:externalId',
  subCategories: '/v1/api/platform/help-center/sub-categories/:intercomId',
  createSubCategory: '/v1/api/platform/help-center/:parentExternalId/sub-category',
  banners: '/v1/api/platform/help-center/banners',
  createBanner: '/v1/api/platform/help-center/categories/:externalId/banners',
  updateBanner: '/v1/api/platform/help-center/banners/:externalId',
  deleteBanner: '/v1/api/platform/help-center/banners/delete/:externalId',
  kustomerUpdate: '/v1/api/platform/help-center/kustomer/update',
};

/** Upstream GET /categories defaults to size=5000 (effectively "all"); we ask for a smaller,
 * still-generous page since the panel doesn't need true server pagination for this dataset. */
export const CATEGORIES_FETCH_SIZE = 500;

export const PAGE_SIZE = 25;

/**
 * ELanguage wire values (help-center-dto `ELanguage` / support-gateway-dto mirror), snake_case
 * locale codes despite the enum name — NOT ISO language codes.
 */
export const LANGUAGE_OPTIONS = [
  { value: 'en_us', label: 'English' },
  { value: 'es_ar', label: 'Spanish' },
  { value: 'pt_br', label: 'Portuguese' },
] as const;

export type TLanguageValue = (typeof LANGUAGE_OPTIONS)[number]['value'];

/**
 * Query keys for React Query. Hierarchical structure for cache management.
 */
export const ContentKeys = {
  all: () => ['help-center', 'content'] as const,
  categories: (filters: Record<string, unknown> = {}) =>
    [...ContentKeys.all(), 'categories', filters] as const,
  categoryArticles: (externalId: string | null, lang: string) =>
    [...ContentKeys.all(), 'articles', externalId, lang] as const,
  subCategories: (intercomId: string | null) =>
    [...ContentKeys.all(), 'sub-categories', intercomId] as const,
  /* `object` rather than Record<string, unknown>: callers pass the IBannerFilters interface, and an
   * interface has no implicit index signature, so Record<string, unknown> rejects it. Declaring the
   * filter type here instead would make config <-> service imports circular. */
  banners: (filters: object = {}) => [...ContentKeys.all(), 'banners', filters] as const,
};
